import { useTranslation } from 'react-i18next';
import i18nInstance from '../localeImport.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SelfCustodyViaWeb3Auth() {
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  return /*#__PURE__*/jsxs("div", {
    className: "w3a--flex w3a--items-center w3a--gap-2 w3a--justify-center",
    children: [/*#__PURE__*/jsx("div", {
      className: "w3a--text-xs w3a--text-app-gray-300 dark:w3a--text-app-gray-500",
      children: t("modal.footer.message-new")
    }), /*#__PURE__*/jsx("img", {
      height: "16",
      src: "https://images.web3auth.io/web3auth-footer-logo-light.svg",
      alt: "Web3Auth Logo Light",
      className: "w3a--h-4 w3a--block dark:w3a--hidden"
    }), /*#__PURE__*/jsx("img", {
      height: "16",
      src: "https://images.web3auth.io/web3auth-footer-logo-dark.svg",
      alt: "Web3Auth Logo Dark",
      className: "w3a--h-4 w3a--hidden dark:w3a--block"
    })]
  });
}

export { SelfCustodyViaWeb3Auth as default };
